import { useNavigate } from 'react-router-dom';
import { FC } from 'react';

import { PdfViewer } from 'src/components/pdf-viewer';
import { routes } from 'src/constants/routes';
import { useBookingTermsPdfData } from 'src/lib/hooks/use-get-booking-terms-pdf-data';

import { Building } from '../../shared/types/building';

export const BookingTermsContent: FC<{ building: Building }> = ({ building }) => {
    const { data, isPending, isError } = useBookingTermsPdfData(building);
    const navigate = useNavigate();

    if (isError) {
        navigate(routes.failure.index);
    }

    return <PdfViewer file={data} isLoading={isPending} name="booking-terms" />;
};
